import React, { useMemo } from 'react';

import { TAxisXCustomProps } from 'src/components/_charts/AxisXCustom/AxisXCustom.types';
import { UTCMoment } from 'src/utils/UTCMoment';
import classNames from 'classnames';
import s from './AxisXCustom.module.scss';

export const AxisXCustom: React.FC<TAxisXCustomProps> = React.memo(
  ({ className, startUnix, endUnix }) => {
    const startMoment = useMemo(() => UTCMoment.fromUnix(startUnix || 0), [startUnix]);

    if (!endUnix || !startUnix) return <div className={classNames(s.container, className)} />;

    const hours = (endUnix - startUnix) / 60 / 60;
    const ticks: JSX.Element[] = [];

    if (hours <= 24) {
      for (let i = 0; i <= hours; i++) {
        if (!(i % 4) && i !== 24) {
          ticks.push(<div key={i}>{i}h</div>);
        } else {
          ticks.push(<div key={i} />);
        }
      }
    } else {
      for (let i = 0; i <= hours; i++) {
        if (!(i % 24)) {
          const days = i / 24;
          ticks.push(<div key={i}>{startMoment.clone().add(days, 'days').format('MMM D')}</div>);
        } else {
          ticks.push(<div key={i} />);
        }
      }
    }

    return <div className={classNames(s.container, className)}>{ticks}</div>;
  },
);
